export default __webpack_public_path__ + "static/media/ProximaNova-Semibold.be42827a.ttf";